import React from 'react';
import { LoadingIndicatorProps } from 'react-select';
import { Flex } from '@chakra-ui/react';

import Loader from 'components/Loader';

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props) => {
  const { innerProps } = props;

  return (
    <Flex
      {...innerProps}
      alignItems="center"
      justifyContent="center"
      minW="32px"
      minH="32px"
    >
      <Loader />
    </Flex>
  );
};

export default LoadingIndicator;
